import { scrollToTop } from '../util/scroll'
import type { QuizElement } from './quiz'

up.compiler('[data-video-quiz-switcher]', (element: HTMLElement) => {
  const LOCATION_QUIZ_HASH = '#quiz'
  let switchTarget: string

  const videoContent = element.querySelector<HTMLElement>(
    '[data-video-quiz-switcher--content="video"]',
  )!
  const quizContent = element.querySelector<HTMLElement>(
    '[data-video-quiz-switcher--content="quiz"]',
  )!

  if (window.location.hash === LOCATION_QUIZ_HASH) {
    switchTarget = 'quiz'
    switchToTarget({ scrollTop: false })
  }

  up.on(
    element,
    'click player:switch',
    '[data-video-quiz-switcher--switch]',
    (event: Event, link: HTMLElement) => {
      event.preventDefault()
      switchTarget = link.getAttribute('data-video-quiz-switcher--switch')!
      switchToTarget({ scrollTop: event.type !== 'player:switch' })
    },
  )

  function onSwitchToVideo(event: Event): void {
    event.preventDefault()
    switchTarget = 'video'
    switchToTarget({ scrollTop: true })
  }

  function onSwitchToQuiz(event: Event): void {
    event.preventDefault()
    switchTarget = 'quiz'
    switchToTarget({ scrollTop: true })
  }

  function switchToTarget({ scrollTop = true } = {}): void {
    switchContent()
    toggleActiveButtons()
    toggleLocationHash()

    if (scrollTop) scrollToTop()

    if (switchTarget === 'quiz') {
      up.emit('app:main-player:pause')
      up.emit('app:main-player:move-to-background')
      void quizContent
        .querySelector<QuizElement>('[data-quiz]')
        ?.startQuiz()
        ?.then(() => {
          ;(quizContent.querySelector('.quiz-question--head') as HTMLElement | null)?.focus()
        })
    } else {
      up.emit('app:main-player:move-to-foreground')
      ;(
        videoContent.querySelector('.vjs-custom-big-play-and-pause-button') as HTMLElement | null
      )?.focus()
    }
  }

  function switchContent(): void {
    videoContent.classList.toggle('-hidden', switchTarget !== 'video')
    quizContent.classList.toggle('-hidden', switchTarget !== 'quiz')
  }

  function toggleActiveButtons(): void {
    element.querySelectorAll('[data-video-quiz-switcher--switch]').forEach((content) => {
      content.classList.toggle(
        '-active',
        content.getAttribute('data-video-quiz-switcher--switch') === switchTarget,
      )
    })
  }

  function toggleLocationHash(): void {
    const newPathName =
      switchTarget === 'video'
        ? window.location.pathname
        : window.location.pathname + LOCATION_QUIZ_HASH
    history.replaceState('', document.title, newPathName)
  }

  return [
    up.on('player:switch:video', onSwitchToVideo),
    up.on('player:switch:quiz', onSwitchToQuiz),
  ]
})
